import React, { useContext } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

/**
 * NotFoundPage Component - A friendly fallback for routes that do not exist.
 * Logged-in users are sent back to the main page, while logged-out users are sent to login.
 */
const NotFoundPage = () => {
  // Read token from AuthContext to decide which navigation action is most useful.
  const { token } = useContext(AuthContext);

  return (
    // Main container to center the not-found message on the screen.
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Row className="w-100">
        <Col md={6} lg={4} className="mx-auto">
          {/* Card component for displaying the not-found state. */}
          <Card className="shadow-sm">
            <Card.Body className="text-center">
              {/* Logo and heading. */}
              <div className="mb-4">
                <img
                  alt="AGRISMART logo"
                  src="/android-chrome-192x192.png"
                  width="60"
                  height="60"
                  className="text-primary"
                />
                <h2 className="mt-2">Page not found</h2>
              </div>

              {/* Clear explanation for unknown URLs. */}
              <p className="text-muted mb-4">
                The page you are looking for does not exist.
              </p>

              {/* Send authenticated users home and unauthenticated users back to login. */}
              <Button as={Link} to={token ? '/' : '/login'} variant="primary" className="w-100">
                {token ? 'Back to main page' : 'Back to login'}
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFoundPage;
